const { debounce, viewportSize } = window.BAO.Utils

class QuickBuy extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.close = this.close.bind(this)

    this.listeners.add(document, 'click', this.handleTrigger)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_ADD_FROM_FORM,
      this.close,
    )

    this.listeners.add(
      window,
      'resize',
      debounce(this.handleResize.bind(this), 100),
    )
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-quick-buy-external-el="trigger"]',
    )

    if (!trigger) return

    if (trigger.hasAttribute('data-quick-buy-reopen')) {
      this.reopen(trigger)
      return
    }

    if (
      trigger.hasAttribute('data-bis') &&
      trigger.getAttribute('data-bis') !== 'false'
    ) {
      // Prevent the form from submitting and triggering a page reload.
      event.preventDefault()
    }

    const sectionName = trigger.dataset.sectionName

    try {
      const res = await window.BAO.sectionRenderer.fetchSingle(
        sectionName,
        trigger.dataset.productUrl,
      )

      const sectionId = `shopify-section-${sectionName}`

      const sectionHTML = window.BAO.sectionRenderer.getOuterHtml(res, {
        id: sectionId,
      })

      this.els.content.element.innerHTML = sectionHTML

      try {
        if (typeof iWish !== 'undefined') {
          setTimeout(() => {
            /* eslint-disable-next-line no-undef */
            iWish.checkIwishColl()
          }, 1500)
        }
      } catch (error) {
        console.warn(error)
      }

      if (trigger.hasAttribute('data-bis')) {
        const bisFormElem = this.els.content.element.querySelector(
          '[data-product-back-in-stock-form]',
        )

        bisFormElem.setAttribute('data-variant-id', trigger.dataset.variantId)
        bisFormElem.setAttribute(
          'data-variant-title',
          trigger.dataset.variantTitle,
        )
        bisFormElem.setAttribute('data-product-id', trigger.dataset.productId)
        bisFormElem.setAttribute('aria-hidden', 'false')

        const title = bisFormElem.querySelector('[data-title]')
        title.textContent = `${title.textContent} '${trigger.dataset.variantTitle}'`
      }

      this.dataset.content = sectionName

      this.checkQuickBuySelectedVariant()

      this.open(trigger)
    } catch (error) {
      console.error(error)
    }
  }

  open (trigger) {
    window.drawers.triggerButton = trigger
    window.drawers.activeDrawerKey = 'quick-buy'

    document.dispatchEvent(
      new CustomEvent('drawerOpen', { detail: { key: 'quick-buy' } }),
    )

    if (this.externalEls.drawer?.exists) {
      window.BAO.Utils.trapFocus(this.externalEls.drawer.element)

      window.setTimeout(() => {
        this.externalEls.drawer.element
          .querySelector('[data-drawers-close]')
          ?.focus()
      }, 300)
    }
  }

  reopen (trigger) {
    this.checkQuickBuySelectedVariant()

    this.open(trigger)
  }

  checkQuickBuySelectedVariant () {
    if (this.dataset.content !== 'product-quick-buy') return

    const variantId =
      new URLSearchParams(window.location.search)?.get('variant') || null
    if (!variantId) return

    const matchingVariantRadioEl = Array.from(
      this.querySelectorAll('[data-variant-radios-el="option-choice"]'),
    ).find(el => el.getAttribute('data-variant-id') === variantId)

    if (matchingVariantRadioEl && matchingVariantRadioEl.checked === false) {
      matchingVariantRadioEl.click()
    }
  }

  close () {
    if (window.drawers.activeDrawerKey !== 'quick-buy') return

    window.drawers.activeDrawerKey = ''
    window.drawers.triggerButton?.focus()

    document.dispatchEvent(
      new CustomEvent('drawerClosed', { detail: { key: 'quick-buy' } }),
    )

    window.BAO.Utils.disableTrapFocus()
  }

  handleResize () {
    if (
      viewportSize() !== 'xs' &&
      window.drawers.activeDrawerKey === 'quick-buy'
    ) {
      this.close()
    }
  }
}

if (!customElements.get('quick-buy')) {
  customElements.define('quick-buy', QuickBuy)
}
